import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { batchList } from "../../../api/Batch";
import { useLocation, useNavigate } from "react-router-dom";
import {
  studentBatchEnrollV4,
  studentDetailsV2,
  studentsListOnly,
} from "../../../api/Student";
import Master from "../Master";
import StudentEMI from "../../student_v2/StudentEMI";
import useAppConfig from "../../config/useAppConfig";
import { StaffList } from "../../../api/Staff";
import { discountOffersList } from "../../../api/DiscountOffers";

export default function StudentEnrollBatchV4() {
  const navigate = useNavigate();
  const config = useAppConfig("RTE", "rte_workflow");
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);
  const [data, setData] = useState({});
  const [courseData, setCourseData] = useState({});
  const [studentInfo, setStudentInfo] = useState({});
  const [staffs, setStaffs] = useState([]);

  const location = useLocation();
  const queryParam = new URLSearchParams(location.search);
  const student_id = queryParam.get("student_id");
  const batch_id = queryParam.get("batch_id");
  const [selectedFees, setSelectedFees] = useState({});
  const [discountData, setDiscountData] = useState({
    type: "fixed",
    value: "",
  });
  const [offers, setOffers] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState("");
  const [selectedOfferRemark, setSelectedOfferRemark] = useState("");

  const getStudentDetails = async (id) => {
    try {
      const response = await studentDetailsV2(`id=${id}`);
      if (response?.data?.status) {
        setStudentInfo(response?.data?.data || {});
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getStaffs = async () => {
    const addUrl = `status=1`;
    setLoading(true);
    try {
      const response = await StaffList(addUrl);
      if (response.data.status) {
        setStaffs(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const selectedStudentId = data?.student_id || student_id;

  useEffect(() => {
    if (selectedStudentId) {
      getStudentDetails(selectedStudentId);
    }
  }, [selectedStudentId]);

  const getBatchList = async () => {
    setLoading(true);
    try {
      let addUrl = ``;
      if (data?.session_id) {
        addUrl += `session_id=${data?.session_id}`;
      }
      const response = await batchList(addUrl);
      if (response.data.status) {
        setBatches(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStudentList = async () => {
    setLoading(true);
    try {
      let addUrl = ``;
      if (data?.session_id) {
        addUrl += `session_id=${data?.session_id}`;
      }
      const response = await studentsListOnly(addUrl);
      if (response.data.status) {
        setStudents(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
    getStaffs();
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1);
    if (!activeSession) return;
    setData((prev) => ({
      ...prev,
      session_id: activeSession.id,
    }));
  }, [sessions]);

  useEffect(() => {
    getBatchList();
  }, [data?.session_id]);

  useEffect(() => {
    if (data?.session_id) {
      getStudentList();
    }
  }, [data?.session_id]);

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await studentBatchEnrollV4(formData);
      if (response?.data?.status) {
        if (studentInfo?.bus_status === "Yes") {
          navigate(`/student/bus/enroll?student_id=${selectedStudentId}`);
        } else {
          navigate(`/student/details?id=${selectedStudentId}`);
        }
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!batch_id) return;
    setData((prev) => ({
      ...prev,
      batch_id,
    }));
  }, [batch_id]);

  useEffect(() => {
    if (!data?.batch_id) return;

    const selectedBatch = batches?.find(
      (b) => Number(b.id) === Number(data.batch_id),
    );

    if (!selectedBatch) return;

    let fees = (selectedBatch?.fee_details || []).map((fee) => ({
      ...fee,
      amount: Number(fee.amount || 0),
      final_amount: Number(fee.amount || 0),
      actual_amount: Number(fee.amount || 0),
    }));

    if (studentInfo?.course_and_fee_info) {
      fees = fees.map((fee) =>
        fee.fee_type === "Registration Fee" && fee.apply_on === "New Student"
          ? {
              ...fee,
              amount: 0,
              final_amount: 0,
            }
          : fee,
      );
    }

    let rteConfig = [];

    try {
      rteConfig = JSON.parse(config?.value || "[]");
    } catch (e) {}

    if (data?.rte_status === "RTE") {
      fees = fees.map((fee) => {
        const key = fee.fee_type
          ?.toLowerCase()
          ?.trim()
          ?.replace(/[^a-z0-9]+/g, "_")
          ?.replace(/^_|_$/g, "");

        const isFree = rteConfig?.find(
          (x) => x.key === key && Number(x.value) === 1,
        );

        return isFree
          ? {
              ...fee,
              amount: 0,
              final_amount: 0,
            }
          : fee;
      });
    }

    const total = fees.reduce((sum, fee) => sum + Number(fee.amount || 0), 0);
    const final_amount = fees.reduce(
      (sum, fee) => sum + Number(fee.final_amount || 0),
      0,
    );

    setCourseData({
      ...selectedBatch,
      fee_details: fees,
      total_fee: total,
      final_fee: final_amount,
    });
  }, [data?.batch_id, data?.rte_status, studentInfo, config, batches]);

  useEffect(() => {
    if (courseData?.fee_details?.length) {
      const obj = {};

      courseData.fee_details.forEach((_, index) => {
        obj[index] = true;
      });

      setSelectedFees(obj);
    }
  }, [courseData?.fee_details]);

  const getFeesSummary = (fees, checkedFees) => {
    return fees.reduce(
      (acc, fee, index) => {
        if (checkedFees[index]) {
          acc.total += Number(fee.amount || 0);
          acc.final += Number(fee.final_amount || 0);
        }

        return acc;
      },
      {
        total: 0,
        final: 0,
      },
    );
  };

  const PREVIOUS_SESSION_FEE_TYPE = "Previous Session Fees";

  const handleAddPreviousSessionFee = () => {
    setCourseData((prev) => {
      const alreadyExists = (prev?.fee_details || []).some(
        (fee) => fee.fee_type === PREVIOUS_SESSION_FEE_TYPE,
      );

      if (alreadyExists) {
        return prev;
      }

      return {
        ...prev,
        fee_details: [
          ...(prev?.fee_details || []),
          {
            fee_type: PREVIOUS_SESSION_FEE_TYPE,
            amount: 0,
            final_amount: 0,
            actual_amount: 0,
            apply_on: null,
            custom: true,
          },
        ],
      };
    });
  };

  const handleRemovePreviousSessionFee = (index) => {
    setCourseData((prev) => {
      const fee_details = (prev?.fee_details || []).filter(
        (_, i) => i !== index,
      );

      const summary = getFeesSummary(fee_details, selectedFees);

      return {
        ...prev,
        fee_details,
        total_fee: summary.total,
        final_fee: summary.final,
      };
    });
  };

  const handlePreviousFeeAmountChange = (index, value) => {
    const amount = Math.max(0, Number(value || 0));

    setCourseData((prev) => {
      const fee_details = (prev?.fee_details || []).map((fee, i) =>
        i === index
          ? { ...fee, amount, final_amount: amount, actual_amount: amount }
          : fee,
      );

      const summary = getFeesSummary(fee_details, selectedFees);

      return {
        ...prev,
        fee_details,
        total_fee: summary.total,
        final_fee: summary.final,
      };
    });
  };

  const calculateDiscount = (type, value) => {
    const totalFee = Number(courseData.total_fee || 0);

    let discountValue = Number(value || 0);

    // Limit discount
    if (type === "fixed") {
      discountValue = Math.min(discountValue, totalFee);
    } else {
      discountValue = Math.min(discountValue, 100);
    }

    // Calculate expected final fee
    let expectedFinal =
      type === "fixed"
        ? totalFee - discountValue
        : totalFee - (totalFee * discountValue) / 100;

    expectedFinal = Math.max(0, Math.round(expectedFinal));

    // Calculate fee wise discount
    let updatedFees = courseData.fee_details.map((fee, index) => {
      if (!selectedFees[index]) return fee;

      const amount = Number(fee.amount);

      // Registration Fee and Previous Session Fees are never discounted
      if (
        fee.fee_type === "Registration Fee" ||
        fee.fee_type === PREVIOUS_SESSION_FEE_TYPE
      ) {
        return {
          ...fee,
          final_amount: amount,
        };
      }

      let finalAmount = amount;

      if (type === "fixed") {
        const ratio = amount / totalFee;
        const feeDiscount = discountValue * ratio;
        finalAmount = amount - feeDiscount;
      } else {
        finalAmount = amount - (amount * discountValue) / 100;
      }

      finalAmount = Math.max(0, finalAmount);

      return {
        ...fee,
        final_amount: Math.round(finalAmount),
      };
    });

    // Current total after rounding
    let currentTotal = updatedFees.reduce((sum, fee, index) => {
      return selectedFees[index] ? sum + Number(fee.final_amount || 0) : sum;
    }, 0);

    // Adjust rounding difference
    let diff = expectedFinal - currentTotal;

    if (diff !== 0) {
      for (let i = updatedFees.length - 1; i >= 0; i--) {
        if (
          selectedFees[i] &&
          updatedFees[i].fee_type !== "Registration Fee" &&
          updatedFees[i].fee_type !== PREVIOUS_SESSION_FEE_TYPE
        ) {
          updatedFees[i].final_amount = Math.max(
            0,
            Number(updatedFees[i].final_amount) + diff,
          );
          break;
        }
      }
    }

    // Final total
    const finalFee = updatedFees.reduce((sum, fee, index) => {
      return selectedFees[index] ? sum + Number(fee.final_amount || 0) : sum;
    }, 0);

    setCourseData((prev) => ({
      ...prev,
      fee_details: updatedFees,
      final_fee: Math.max(0, finalFee),
    }));
  };

  const getDiscountOffers = async (batchId) => {
    if (!batchId) return;

    setLoading(true);

    try {
      const addUrl = `status=1&batch_id=${batchId}`;

      const response = await discountOffersList(addUrl);

      if (response.data.status) {
        setOffers(response.data.data || []);
      } else {
        setOffers([]);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data?.batch_id) {
      getDiscountOffers(data.batch_id);
    } else {
      setOffers([]);
    }
  }, [data?.batch_id]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <form onSubmit={handleAdd} method="post">
                          <div className="d-flex justify-content-between align-items-center">
                            <h4 className="text-primary mb-0">
                              Student Batch Enroll
                            </h4>

                            <div className="">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="student_id"
                                  value={data?.student_id || student_id || ""}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      student_id: e.target.value,
                                    })
                                  }
                                >
                                  <option value="" disabled selected>
                                    Select Student
                                  </option>
                                  {students?.map((student) => (
                                    <option
                                      key={student?.id}
                                      value={student?.id}
                                    >
                                      {student?.name} (
                                      {student?.registration_no}) -{" "}
                                      {student?.phone}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Student</label>
                              </div>
                            </div>
                          </div>

                          <hr />
                          <div className="row g-4">
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="session_id"
                                  value={data?.session_id}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      session_id: e.target.value,
                                    })
                                  }
                                >
                                  {sessions?.map((session) => (
                                    <option
                                      key={session?.id}
                                      value={session?.id}
                                    >
                                      {session?.session}:
                                      {Number(session?.status) === 1
                                        ? "Active"
                                        : " Inactive"}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Session</label>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="batch_id"
                                  value={data?.batch_id}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      batch_id: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">
                                    Select Batch & Course
                                  </option>
                                  {batches?.map((batch) => (
                                    <option key={batch?.id} value={batch?.id}>
                                      {batch?.title} ({batch?.course?.title})
                                    </option>
                                  ))}
                                </select>
                                <label>Select Batch & Course</label>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="counselor_id"
                                  className="form-control form-select"
                                >
                                  <option value="">Select Staff</option>
                                  {staffs?.map((staff, i) => (
                                    <option key={i} value={staff?.id}>
                                      {staff?.name} ({staff?.registration_no})
                                    </option>
                                  ))}
                                </select>
                                <label> Assign Staff</label>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="rte_status"
                                  value={data?.rte_status || "NON-RTE"}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      rte_status: e.target.value,
                                    })
                                  }
                                >
                                  <option value="NON-RTE">
                                    NON-RTE Student
                                  </option>
                                  <option value="RTE">RTE Student</option>
                                </select>

                                <label>Select Student Type</label>
                              </div>
                            </div>

                            {courseData?.id && (
                              <>
                                <div className="col-12">
                                  <h6 className="text-primary mt-0 mb-2">
                                    Subject Details
                                  </h6>
                                  <div className="row g-3">
                                    {courseData?.course?.subjects_data?.map(
                                      (subject, i) => (
                                        <div
                                          className="col-auto me-4 text-nowrap"
                                          key={i}
                                        >
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              name="subjects[]"
                                              value={JSON.stringify(subject)}
                                              id={`subject_${subject?.id}`}
                                              defaultChecked={true}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={subject?.id}
                                            >
                                              {subject?.name} (
                                              {subject?.subject_code})
                                            </label>
                                          </div>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                </div>

                                <div className="col-12">
                                  <div className="d-flex justify-content-between align-items-center mt-0 mb-2">
                                    <h6 className="text-primary mb-0">
                                      Fee Details
                                    </h6>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={handleAddPreviousSessionFee}
                                    >
                                      + Add Previous Session Fee
                                    </button>
                                  </div>

                                  <div className="row g-3 align-items-end">
                                    <input
                                      type="hidden"
                                      name="course_id"
                                      value={courseData?.course_id}
                                    />
                                    {courseData?.fee_details?.map(
                                      (fee, index) => (
                                        <div className="col-auto" key={index}>
                                          <div className="form-check d-flex align-items-center">
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              name={`fee_apply[${index}]`}
                                              value="1"
                                              id={`fee_${index}`}
                                              checked={
                                                fee?.fee_type ===
                                                "Registration Fee"
                                                  ? true
                                                  : selectedFees[index] || false
                                              }
                                              onChange={(e) => {
                                                let updated = {};
                                                if (
                                                  fee?.fee_type ===
                                                  "Registration Fee"
                                                ) {
                                                  updated = {
                                                    ...selectedFees,
                                                    [index]: true,
                                                  };
                                                } else {
                                                  updated = {
                                                    ...selectedFees,
                                                    [index]: e.target.checked,
                                                  };
                                                }

                                                setSelectedFees(updated);

                                                const summary = getFeesSummary(
                                                  courseData.fee_details,
                                                  updated,
                                                );

                                                setCourseData((prev) => ({
                                                  ...prev,
                                                  total_fee: summary.total,
                                                  final_fee: summary.final,
                                                }));
                                              }}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`fee_${index}`}
                                            >
                                              {fee.fee_type} (₹
                                              {fee.actual_amount})
                                            </label>
                                            {fee.custom && (
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-link text-danger p-0 ms-2"
                                                title="Remove"
                                                onClick={() =>
                                                  handleRemovePreviousSessionFee(
                                                    index,
                                                  )
                                                }
                                              >
                                                &times;
                                              </button>
                                            )}
                                          </div>

                                          {selectedFees[index] && (
                                            <>
                                              <input
                                                type="hidden"
                                                name={`fee_type[${index}]`}
                                                value={fee.fee_type}
                                              />
                                              <input
                                                type="hidden"
                                                name={`total[${index}]`}
                                                value={fee.amount}
                                              />
                                              <input
                                                type="hidden"
                                                name={`actual_amount[${index}]`}
                                                value={fee.actual_amount}
                                              />

                                              <div className="form-floating form-floating-outline">
                                                {fee.custom ? (
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    name={`final[${index}]`}
                                                    value={fee.final_amount}
                                                    min="0"
                                                    onChange={(e) =>
                                                      handlePreviousFeeAmountChange(
                                                        index,
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    name={`final[${index}]`}
                                                    value={fee.final_amount}
                                                    min="0"
                                                    // onChange={(e) => {
                                                    //   let value = 0;
                                                    //   if (
                                                    //     fee?.fee_type ===
                                                    //     "Registration Fee"
                                                    //   ) {
                                                    //     value = Number(
                                                    //       fee?.amount,
                                                    //     );
                                                    //   } else {
                                                    //     value = Number(
                                                    //       e.target.value || 0,
                                                    //     );
                                                    //   }

                                                    //   const updatedFees = [
                                                    //     ...courseData.fee_details,
                                                    //   ];

                                                    //   updatedFees[index] = {
                                                    //     ...updatedFees[index],
                                                    //     final_amount: value,
                                                    //   };

                                                    //   const total =
                                                    //     updatedFees.reduce(
                                                    //       (sum, item, i) => {
                                                    //         return selectedFees[i]
                                                    //           ? sum +
                                                    //               Number(
                                                    //                 item.amount ||
                                                    //                   0,
                                                    //               )
                                                    //           : sum;
                                                    //       },
                                                    //       0,
                                                    //     );

                                                    //   const final_amount =
                                                    //     updatedFees.reduce(
                                                    //       (sum, item, i) => {
                                                    //         return selectedFees[i]
                                                    //           ? sum +
                                                    //               Number(
                                                    //                 item.final_amount ||
                                                    //                   0,
                                                    //               )
                                                    //           : sum;
                                                    //       },
                                                    //       0,
                                                    //     );

                                                    //   setCourseData((prev) => ({
                                                    //     ...prev,
                                                    //     fee_details: updatedFees,
                                                    //     total_fee: total,
                                                    //     final_fee: final_amount,
                                                    //   }));
                                                    // }}
                                                  />
                                                )}
                                                <label>Amount</label>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      ),
                                    )}
                                    <div className="col-auto">
                                      <div className="form-floating form-floating-outline">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="total_fee"
                                          placeholder="Total Fee"
                                          value={courseData?.total_fee}
                                          readOnly
                                        />
                                        <label>Total Fee</label>
                                      </div>
                                    </div>

                                    {offers?.length > 0 ? (
                                      <>
                                        <div className="col-auto">
                                          <div className="form-floating form-floating-outline">
                                            <select
                                              className="form-select"
                                              value={selectedOffer}
                                              onChange={(e) => {
                                                const value = e.target.value;

                                                setSelectedOffer(value);

                                                if (!value) {
                                                  setSelectedOfferRemark("");

                                                  setDiscountData({
                                                    type: "percentage",
                                                    value: "",
                                                  });

                                                  calculateDiscount(
                                                    "percentage",
                                                    0,
                                                  );
                                                  return;
                                                }

                                                const offer = offers.find(
                                                  (item) =>
                                                    Number(item.id) ===
                                                    Number(value),
                                                );

                                                if (!offer) return;

                                                setSelectedOfferRemark(
                                                  offer.title || "",
                                                );

                                                setDiscountData({
                                                  type: "percentage",
                                                  value:
                                                    offer.discount_percentage,
                                                });

                                                calculateDiscount(
                                                  "percentage",
                                                  offer.discount_percentage,
                                                );
                                              }}
                                            >
                                              <option value="">
                                                Select Discount Offer
                                              </option>

                                              {offers.map((offer) => (
                                                <option
                                                  key={offer.id}
                                                  value={offer.id}
                                                >
                                                  {offer?.title} (
                                                  {offer.discount_percentage}%)
                                                </option>
                                              ))}
                                            </select>

                                            <label>Select Discount Offer</label>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="col-auto">
                                          <div className="form-floating form-floating-outline">
                                            <select
                                              name="discount_type"
                                              className="form-select"
                                              value={discountData.type}
                                              onChange={(e) => {
                                                const type = e.target.value;

                                                setDiscountData((prev) => ({
                                                  ...prev,
                                                  type,
                                                }));

                                                calculateDiscount(
                                                  type,
                                                  discountData.value,
                                                );
                                              }}
                                            >
                                              <option value="fixed">
                                                Fixed ₹
                                              </option>
                                              <option value="percentage">
                                                Percentage %
                                              </option>
                                            </select>
                                            <label>Discount Type</label>
                                          </div>
                                        </div>
                                        <div className="col-auto">
                                          <div className="form-floating form-floating-outline">
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Discount"
                                              value={discountData.value}
                                              onChange={(e) => {
                                                const value = Number(
                                                  e.target.value || 0,
                                                );

                                                setDiscountData((prev) => ({
                                                  ...prev,
                                                  value,
                                                }));

                                                calculateDiscount(
                                                  discountData.type,
                                                  value,
                                                );
                                              }}
                                            />
                                            <label>
                                              {discountData.type === "fixed"
                                                ? "Discount ₹"
                                                : "Discount %"}
                                            </label>
                                          </div>
                                        </div>
                                      </>
                                    )}

                                    <div className="col-auto">
                                      <div className="form-floating form-floating-outline">
                                        <input
                                          type="number"
                                          name="final_fee"
                                          className="form-control"
                                          readOnly
                                          value={courseData?.final_fee}
                                          onChange={(e) => {
                                            let value = Number(
                                              e.target.value || 0,
                                            );

                                            if (
                                              value >
                                              Number(courseData.total_fee)
                                            ) {
                                              value = Number(
                                                courseData.total_fee,
                                              );
                                            }

                                            setCourseData((prev) => ({
                                              ...prev,
                                              final_fee: value,
                                            }));
                                          }}
                                        />
                                        <label>Final Fee</label>
                                      </div>
                                    </div>
                                    {courseData?.total_fee -
                                      courseData?.final_fee >
                                      0 && (
                                      <div className="col-auto">
                                        <div className="form-floating form-floating-outline">
                                          <input
                                            type="text"
                                            className="form-control input-uppercase"
                                            name="discount_remark"
                                            placeholder="Discount Remark"
                                            required
                                            value={selectedOfferRemark}
                                            onChange={(e) =>
                                              setSelectedOfferRemark(
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <label>Discount Remark</label>
                                        </div>
                                      </div>
                                    )}

                                    {Number(courseData?.final_fee) > 0 && (
                                      <StudentEMI
                                        finalFee={courseData?.final_fee}
                                      />
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="col-12 text-end">
                              <button
                                type="submit"
                                disabled={loading}
                                className="btn btn-sm btn-primary px-12"
                              >
                                {loading ? "Saving..." : "Save"}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
